import { ostroAdapter } from '../../services/ostroAdapter';

export function deserialize(string: string) {
  try {
    return JSON.parse(string);
  } catch {
    return string;
  }
}

export function serialize(value: unknown): string {
  try {
    return JSON.stringify(value);
  } catch {
    return '';
  }
}

export function getNamespacedKey(key: string): string {
  return `${key}-${ostroAdapter.ostro.conditionId}`;
}
